import { Box, Button, Divider, Paper, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { treeItemClasses } from '@mui/x-tree-view';

const treeContent = `&& .${treeItemClasses.content}`;
const treeGroup = `&& .${treeItemClasses.groupTransition}`;
const treeLabel = `& .${treeItemClasses.label}`;
const treeIcon = `& .${treeItemClasses.iconContainer}`;

const treeRowBackground = 'transparent';
const treeRowHoverBackground = 'rgba(0, 0, 0, 0.04)';

export const BackButtonWrap = styled(Box)({
  marginBottom: 24,
});

export const BackButton = styled(Button)({
  fontWeight: 700,
  paddingLeft: 0,
  textTransform: 'none',
});

export const DetailsLayout = styled(Box)(({ theme }) => ({
  alignItems: 'stretch',
  display: 'flex',
  gap: 48,
  marginTop: theme.spacing(2.5),
  width: '100%',
}));

export const DetailsInfoColumn = styled(Box)({
  flex: '0 0 420px',
  maxWidth: 460,
});

export const DetailsRolesColumn = styled(Box)({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
});

export const RoleDetailsCard = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.border}`,
  borderRadius: 12,
  boxShadow: 'none',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: '100%',
  padding: 24,
  width: '100%',
}));

export const RoleTreePanel = styled(Box)({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
});

export const SectionDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(4, 0),
}));

export const FieldStack = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
});

export const RoleCardHeader = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 16,
  minHeight: 40,
});

export const RoleCardTitle = styled(Typography)({
  fontWeight: 700,
});

export const RoleCardActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
}));

export const PermissionTreeRoot = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  [treeContent]: {
    alignItems: 'center',
    backgroundColor: treeRowBackground,
    padding: '2px 0',
    '&:hover, &[data-selected]:hover': {
      backgroundColor: treeRowHoverBackground,
    },
    '&[data-focused], &[data-selected], &[data-selected][data-focused]': {
      backgroundColor: treeRowBackground,
    },
    '&[data-disabled]': {
      opacity: 1,
    },
  },
  [treeGroup]: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    marginLeft: 14,
    paddingLeft: 18,
  },
  [treeLabel]: {
    width: '100%',
  },
  [treeIcon]: {
    color: theme.palette.text.secondary,
  },
  '& .MuiCheckbox-root': {
    color: theme.palette.primary.main,
    padding: 4,
  },
  '& .MuiCheckbox-root.Mui-disabled': {
    color: theme.palette.action.disabled,
  },
}));

export const PermissionTreeLabel = styled(Box)({
  alignItems: 'baseline',
  display: 'flex',
  gap: 12,
  minWidth: 0,
});

export const PermissionTreeName = styled(Typography)({
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '22px',
  whiteSpace: 'nowrap',
});

export const PermissionTreeDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '22px',
  minWidth: 0,
}));

export const PermissionTreeError = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 12,
  marginTop: theme.spacing(1),
}));
